import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d8c02f90"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row" }

import { computed } from 'vue';
import _, { Dictionary } from 'lodash';

export interface RiskRatingSettingObj {
  symbol1: string;
  symbol2: string;
  value1: number;
  value2: number;
}

export default /*#__PURE__*/_defineComponent({
  props: {
  modelValue: {
    type: Object as () => Dictionary<RiskRatingSettingObj>,
    default: {},
  },
},
  emits: ["update:modelValue"],
  setup(__props, { emit }: { emit: ((event: 'update:modelValue', payload: string) => void), expose: any, slots: any, attrs: any }) {

const props = __props





const moreOptions = [
  { label: '>=', value: 'moreThanOrEquals' },
  { label: '>', value: 'moreThan' },
];
const lessOptions = [
  { label: '<=', value: 'lessThanOrEquals' },
  { label: '<', value: 'lessThan' },
];

const obj = computed(() => props.modelValue);

const update = (key1: string, key2: string, value: number | string) => {
  const clonedObj = _.cloneDeep(obj.value);
  clonedObj[key1][key2] = value;
  emit('update:modelValue', clonedObj as any);
};

return (_ctx: any,_cache: any) => {
  const _component_simple_select = _resolveComponent("simple-select")!
  const _component_simple_input = _resolveComponent("simple-input")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(_unref(obj)), (key) => {
      return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("span", null, _toDisplayString(key) + "级", 1),
        _createElementVNode("span", null, [
          _createVNode(_component_simple_select, {
            options: _ctx.pocket('levelRangeSymbol'),
            "onUpdate:modelValue": (value) => update(key, 'symbol1', value),
            modelValue: _unref(obj)[key]['symbol1']
          }, null, 8, ["options", "onUpdate:modelValue", "modelValue"])
        ]),
        _createElementVNode("span", null, [
          _createVNode(_component_simple_input, {
            type: "number",
            "onUpdate:modelValue": (value) => update(key, 'value1', value),
            modelValue: _unref(obj)[key]['value1']
          }, null, 8, ["onUpdate:modelValue", "modelValue"])
        ]),
        _createElementVNode("span", null, [
          _createVNode(_component_simple_select, {
            options: _ctx.pocket('levelRangeSymbol'),
            "onUpdate:modelValue": (value) => update(key, 'symbol2', value),
            modelValue: _unref(obj)[key]['symbol2']
          }, null, 8, ["options", "onUpdate:modelValue", "modelValue"])
        ]),
        _createElementVNode("span", null, [
          _createVNode(_component_simple_input, {
            type: "number",
            "onUpdate:modelValue": (value) => update(key, 'value2', value),
            modelValue: _unref(obj)[key]['value2']
          }, null, 8, ["onUpdate:modelValue", "modelValue"])
        ])
      ]))
    }), 256))
  ]))
}
}

})